import { render, staticRenderFns } from "./MemberPopup.vue?vue&type=template&id=5333e3f2&scoped=true&"
import script from "./MemberPopup.vue?vue&type=script&lang=ts&"
export * from "./MemberPopup.vue?vue&type=script&lang=ts&"
import style0 from "./MemberPopup.vue?vue&type=style&index=0&id=5333e3f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5333e3f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
